module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/stacked-2-28f775004fe0010fb13250982ef5d97b.png";